import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Edit2, Link as LinkIcon } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";

const TIPOS_EVENTO = {
  presupuesto_erp: { label: "Presupuesto a ERP", color: "bg-blue-500" },
  lead_creado: { label: "Lead Creado", color: "bg-green-500" },
  lead_actualizado: { label: "Lead Actualizado", color: "bg-yellow-500" }
};

export default function WebhookCard({ webhook, onEdit, onToggleActive }) {
  return (
    <Card className="hover:shadow-lg transition-all duration-200 dark:bg-gray-900 dark:border-gray-800">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-indigo-100 dark:bg-indigo-950 rounded-lg flex items-center justify-center">
              <LinkIcon className="w-5 h-5 text-indigo-600 dark:text-indigo-400" />
            </div>
            <div>
              <CardTitle className="text-lg text-gray-900 dark:text-white">{webhook.nombre}</CardTitle>
              <Badge className={`${TIPOS_EVENTO[webhook.tipo_evento]?.color} text-white mt-2`}>
                {TIPOS_EVENTO[webhook.tipo_evento]?.label}
              </Badge>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={() => onEdit(webhook)}>
            <Edit2 className="w-4 h-4" />
          </Button>
        </div>
      </CardHeader>
      
      <CardContent className="space-y-3">
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">URL</p>
          <p className="text-sm text-gray-700 dark:text-gray-300 font-mono bg-gray-50 dark:bg-gray-800 p-2 rounded break-all">
            {webhook.url}
          </p>
        </div>

        {webhook.campos_incluir && webhook.campos_incluir.length > 0 && (
          <div>
            <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">Campos incluidos</p>
            <div className="flex flex-wrap gap-1">
              {webhook.campos_incluir.map((campo, index) => (
                <Badge key={index} variant="outline" className="text-xs dark:border-gray-700">
                  {campo}
                </Badge>
              ))}
            </div>
          </div>
        )}

        <div className="flex justify-between items-center pt-3 border-t border-gray-200 dark:border-gray-700">
          <span className="text-sm text-gray-600 dark:text-gray-400">Activo</span>
          <Switch
            checked={webhook.activo}
            onCheckedChange={(checked) => onToggleActive(webhook.id, checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
}